'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ajax = require('linksoft/initializers/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _autoQuery = require('linksoft/initializers/auto-query');

var _autoQuery2 = _interopRequireDefault(_autoQuery);

var _dataTable = require('linksoft/initializers/data-table');

var _dataTable2 = _interopRequireDefault(_dataTable);

var _select = require('linksoft/initializers/select2');

var _select2 = _interopRequireDefault(_select);

var _tooltip = require('linksoft/initializers/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _notify = require('linksoft/initializers/notify');

var _notify2 = _interopRequireDefault(_notify);

var _confirm = require('linksoft/initializers/confirm');

var _confirm2 = _interopRequireDefault(_confirm);

var _switcher = require('linksoft/initializers/switcher');

var _switcher2 = _interopRequireDefault(_switcher);

var _trigger = require('linksoft/initializers/trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _showRelated = require('linksoft/initializers/show-related');

var _showRelated2 = _interopRequireDefault(_showRelated);

var _pagination = require('linksoft/initializers/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _dropzone = require('linksoft/initializers/dropzone');

var _dropzone2 = _interopRequireDefault(_dropzone);

var _dispatchAction = require('linksoft/initializers/dispatch-action');

var _dispatchAction2 = _interopRequireDefault(_dispatchAction);

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _clickOnEnter = require('linksoft/initializers/click-on-enter');

var _clickOnEnter2 = _interopRequireDefault(_clickOnEnter);

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

var _moment = require('./initializers/moment');

var _moment2 = _interopRequireDefault(_moment);

var _carousels = require('./initializers/carousels');

var _carousels2 = _interopRequireDefault(_carousels);

var _nestable = require('./initializers/nestable');

var _nestable2 = _interopRequireDefault(_nestable);

var _gallery = require('./initializers/gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _downloadIcons = require('./initializers/downloadIcons');

var _downloadIcons2 = _interopRequireDefault(_downloadIcons);

var _clearModal = require('./initializers/clearModal');

var _clearModal2 = _interopRequireDefault(_clearModal);

var _datepicker = require('./initializers/datepicker');

var _datepicker2 = _interopRequireDefault(_datepicker);

var _advancedSearch = require('./initializers/advancedSearch');

var _advancedSearch2 = _interopRequireDefault(_advancedSearch);

var _advancedSearchSliders = require('./initializers/advancedSearchSliders');

var _advancedSearchSliders2 = _interopRequireDefault(_advancedSearchSliders);

var _activityTracker = require('./initializers/activityTracker');

var _activityTracker2 = _interopRequireDefault(_activityTracker);

var _orderActions = require('./initializers/orderActions');

var _orderActions2 = _interopRequireDefault(_orderActions);

var _userReviewProduct = require('./userReviewProduct');

var _userReviewProduct2 = _interopRequireDefault(_userReviewProduct);

var _customerActions = require('./initializers/customerActions');

var _customerActions2 = _interopRequireDefault(_customerActions);

var _barRating = require('./initializers/barRating');

var _barRating2 = _interopRequireDefault(_barRating);

var _magnificPopup = require('./initializers/magnificPopup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

var _inputAnimation = require('./initializers/inputAnimation');

var _inputAnimation2 = _interopRequireDefault(_inputAnimation);

var _menuResponsive = require('./initializers/menuResponsive');

var _menuResponsive2 = _interopRequireDefault(_menuResponsive);

var _tabs = require('./initializers/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _showHideContent = require('./initializers/showHideContent');

var _showHideContent2 = _interopRequireDefault(_showHideContent);

var _registration = require('./initializers/registration');

var _registration2 = _interopRequireDefault(_registration);

var _newsletter = require('./initializers/newsletter');

var _newsletter2 = _interopRequireDefault(_newsletter);

var _placeholder = require('./initializers/placeholder');

var _placeholder2 = _interopRequireDefault(_placeholder);

var _buyVoucher = require('./initializers/buyVoucher');

var _buyVoucher2 = _interopRequireDefault(_buyVoucher);

var _checkboxRadioValidation = require('./initializers/checkboxRadioValidation');

var _checkboxRadioValidation2 = _interopRequireDefault(_checkboxRadioValidation);

var _productPreview = require('./initializers/productPreview');

var _productPreview2 = _interopRequireDefault(_productPreview);

var _methodicalMaterials = require('./initializers/methodicalMaterials');

var _methodicalMaterials2 = _interopRequireDefault(_methodicalMaterials);

var _stickyCatalogMenu = require('./initializers/stickyCatalogMenu');

var _stickyCatalogMenu2 = _interopRequireDefault(_stickyCatalogMenu);

var _pdfPopup = require('./initializers/pdfPopup');

var _pdfPopup2 = _interopRequireDefault(_pdfPopup);

var _offlineBox = require('./initializers/offlineBox');

var _offlineBox2 = _interopRequireDefault(_offlineBox);

var _catalogLoader = require('./initializers/catalogLoader');

var _catalogLoader2 = _interopRequireDefault(_catalogLoader);

var _events = require('./initializers/events');

var _events2 = _interopRequireDefault(_events);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import autoComplete from './initializers/autocomplete'
// import productSearch from './initializers/productSearch' // distri cart
_lazyImage.options.afterLoad = _linksoftAlbatros.boxHeight;
// import equalHeight from './initializers/equalHeight'
// import productLabel from './initializers/ProductLabel'
// import toggleText from './initializers/toggleText'
//import cartModule from './initializers/cartModule'

_lazyImage.options.onError = _linksoftAlbatros.boxHeight;

exports.default = [_linksoftReact2.default.initializer, _ajax2.default, _autoQuery2.default, _dataTable2.default, _select2.default, _tooltip2.default, _notify2.default, _confirm2.default, _trigger2.default, _switcher2.default, _showRelated2.default, _pagination2.default, _dropzone2.default, _moment2.default, _carousels2.default, _nestable2.default, _downloadIcons2.default, _clearModal2.default, _gallery2.default, _dispatchAction2.default, _lazyImage2.default, _clickOnEnter2.default, _datepicker2.default, _advancedSearch2.default, _advancedSearchSliders2.default, _orderActions2.default, _activityTracker2.default, _userReviewProduct2.default, _customerActions2.default, _barRating2.default, _magnificPopup2.default, _inputAnimation2.default, _menuResponsive2.default, _tabs2.default, _showHideContent2.default, _registration2.default, _newsletter2.default, _placeholder2.default, _buyVoucher2.default, _checkboxRadioValidation2.default, _productPreview2.default, _methodicalMaterials2.default, _stickyCatalogMenu2.default, _pdfPopup2.default, _offlineBox2.default, _catalogLoader2.default, _events2.default];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers.js
// module id = 1161
// module chunks = 0